{
  "CSAT": {
    "TITLE": "Įvertinkite savo pokalbį",
    "PLACEHOLDER": "Papasakokit detaliau...",
    "RATINGS": {
      "POOR": "😞 Blogai",
      "FAIR": "😑 Neblogai",
      "AVERAGE": "😐 Vidutiniškai",
      "GOOD": "😀 Gerai",
      "EXCELLENT": "😍 Puikiai"
    }
  }
}
